import React, { FC, useState } from "react";
import FileUploader from "devextreme-react/file-uploader";
import { IInputProps } from "../../modules/form";
import Axios from "axios";
import { CreateNotification } from "../../components/notifier";
import "react-photo-view/dist/react-photo-view.css";
import FontFa from "../../components/fontFa/fontFa";
import _ from "lodash";
import LoadingSkeleton from "../../LoadingSkeleton";

export const Upload: FC<IInputProps> = ({ value, onChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const fileExtensions = [".pdf", ".docx", ".doc", ".pptx", ".ppt", ".xlsx", ".xls", ".csv", ".png", ".jpg", ".jpeg"];
  // const fileExtensions = [".jpg", ".jpeg", ".gif",".pdf",".docx",".doc",".pptx",".ppt",".xlsx", ".csv", ".png"];

  const handleValueChange = async (event: any) => {
    const file = event.value ? event.value : null;
    if (file.length < 1) {
      onChange && onChange([]);
      return;
    } else {
      if (value && event.previousValue.length > event.value.length) {
        const [deletedItem] = _.differenceWith(event.previousValue, event.value, _.isEqual);
        if (deletedItem) {
          const index = event.previousValue.findIndex((e: any) => _.isEqual(e, deletedItem));
          if (index > -1) {
            const newValue = _.cloneDeep(value) || [];
            newValue?.splice(index, 1);
            onChange(newValue);
          }
        }
        return;
      }
    }
    const listFile = file.filter((e: any) => fileExtensions.includes("." + e.name.split(".").at(-1)));
    if (listFile.length > 0) {
      await handleUploadFile(listFile);
    }
  };

  const handleUploadFile = async (files: any[]) => {
    setIsLoading(true);
    const formData = new FormData();
    files.forEach((file: any) => {
      formData.append("files", file);
    });
    try {
      const response = await Axios.post("https://viagsapi.azurewebsites.net/api/uploadfile/upload-file", formData);
      setIsLoading(false);
      if (response.data.statusCode === 200) {
        const dataFile = response?.data?.data;
        const newFileList = (value || []).concat(dataFile);
        onChange && onChange(newFileList);
      } else {
        CreateNotification({
          title: "Thông báo",
          body: "Định dạng này không hợp lệ, vui lòng chọn các định dạng khác (.pdf,.docx,.doc,.pptx,.ppt,.xlsx)",
          icon: "/icons/error.png",
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  return isLoading ? (
    <LoadingSkeleton isUploadFile={true} />
  ) : (
    <>
      <div className="main-block">
        <div className="file-uploader-block d-flex justify-content-start align-items-center">
          <FileUploader
            multiple={true}
            uploadMode="useForm"
            allowCanceling={true}
            stylingMode="outlined"
            readyToUploadMessage="Tải file thành công"
            invalidMaxFileSizeMessage="Kích thước file quá lớn"
            uploadFailedMessage="Đang tải file, anh/chị vui lòng chờ trong giây lát"
            invalidFileExtensionMessage="Loại tệp tin không được phép, vui lòng chọn lại."
            selectButtonText="Nhấn vào để chọn file"
            labelText="hoặc Kéo thả file vào đây"
            onValueChanged={handleValueChange}
            maxFileSize={4000000}
            allowedFileExtensions={fileExtensions}
            showFileList={false}
          />
        </div>
      </div>
      {value && value?.length > 0 && (
        <div className="px-3 py-1">
          File đã upload:{" "}
          <FileAttachmentCard
            listFile={value}
            onFileChange={onChange}
            isEdit={true}
            isLoading={isLoading}
          ></FileAttachmentCard>
        </div>
      )}
    </>
  );
};

// interface FileAttachment {
//   listFile: [string]; // Đường dẫn đến file đính kèm
//   isEdit?: boolean;
// }

export const FileAttachmentCard: React.FC<any> = ({ listFile, isEdit, onFileChange }) => {
  // const [isShowPopup, setIsShowPopup] = useState(false);

  const getFileType = (fileUrl: string): string => {
    if (typeof fileUrl === "string") {
      const fileExtension = fileUrl?.split(".").pop();
      return fileExtension ? fileExtension.toLowerCase() : "";
    } else return "";
  };

  const getIcon = (fileUrl: string) => {
    const fileType = getFileType(fileUrl);
    switch (fileType) {
      case "doc":
      case "docx":
        return <FontFa name="faFileWord" size="lg" color={"#0F4C81"} />;
      case "pptx":
      case "ppt":
        return <FontFa name="faFilePowerpoint" size="lg" color={"#D04423"} />;
      case "xlsx":
        return <FontFa name="faFileExcel" size="lg" color={"#1d6f42"} />;
      case "pdf":
        return <FontFa name="faFilePdf" size="lg" color={"#B0171F"} />;
      case "png":
      case "jpg":
      case "jepg":
        return <FontFa name="faFileImage" size="lg" color={"#0F4C60"} />;
      default:
        return <FontFa name="faFileCode" size="lg" />;
    }
  };

  const getFileName = (fileUrl: string) => {
    if (typeof fileUrl === "string") {
      const url: string = fileUrl;
      const segments = url.split("/");
      const fileName: string = segments[segments.length - 1];
      return fileName;
    } else return "";
  };

  const handleDeleteClick = (fileUrl: string) => {
    const newFileList = listFile.filter((e: any) => e !== fileUrl);
    onFileChange(newFileList);
  };

  return (
    <>
      {listFile?.length > 0 &&
        Array.isArray(listFile) &&
        listFile?.map((fileUrl: string) => {
          return (
            <div id="container">
              <span className="d-flex align-items-center">
                {getIcon(fileUrl)}
                <a
                  className="mx-1"
                  href={fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ wordBreak: "break-word" }}
                >
                  {getFileName(fileUrl)}
                </a>
                {isEdit && (
                  <p
                    className="mt-1 mx-1"
                    onClick={() => handleDeleteClick(fileUrl)}
                    title="Xóa file này"
                    role="button"
                  >
                    <FontFa name="faTimes" color="#FF6A6A" />
                  </p>
                )}
              </span>
              {/* <Popup
            visible={isShowPopup}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={false}
            showTitle={true}
            title="Thông báo"
            container=".dx-viewport"
            width={3000}
            height={2800}
          >
            <Position
              at="bottom"
              my="center"
              of='container'
              collision="fit"
            />
            <ToolbarItem
              widget="dxButton"
              toolbar="top"
              location="center"
              // locateInMenu="always"
              // options={this.moreInfoButtonOptions}
            />
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="before"
              // options={this.emailButtonOptions}
            />
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              // options={this.closeButtonOptions}
            />
            <p>
              Anh/Chị có muốn xóa file này
            </p>
          </Popup> */}
            </div>
          );
        })}
    </>
  );
};
